import { IntrospectionQuery } from "graphql";
import {
  relayPagination,
  simplePagination
} from "@urql/exchange-graphcache/extras";
import introspection from "generated/introspection.json";
import { cacheExchange, CacheExchangeOpts } from "@urql/exchange-graphcache";
import keys from "./keys";
import Mutation from "./mutationUpdates";
import { TeamsHook, TeamsHookPageFragmentDoc } from "../../generated/graphql";
import { cursorBasedPagination } from "./cursorBasedPagination";
// @ts-ignore
const schema: IntrospectionQuery = introspection as IntrospectionQuery;
export const opts: CacheExchangeOpts = {
  schema,
  updates: {
    Mutation
  },
  keys,
  resolvers: {
    Query: {
      topicIndicators: relayPagination({
        mergeMode: "outwards"
      }),
      devices: simplePagination({
        offsetArgument: "from"
      }),
      tenants: simplePagination({
        offsetArgument: "from"
      }),
      users: relayPagination({
        mergeMode: "outwards"
      }),
      getAuditLogs: simplePagination({
        offsetArgument: "from"
      }),
      licenses: simplePagination({
        offsetArgument: "from"
      })
    },
    NcTeamsQueries: {
      webhook: (_1, args, cache): TeamsHook | null => {
        if (!args.id) return null;
        let readFragment: TeamsHook | null = cache.readFragment<TeamsHook>(
          TeamsHookPageFragmentDoc,
          {
            __typename: "TeamsHook",
            id: `${args.id}`
          }
        );
        if (!readFragment) return null;
        return {
          ...readFragment,
          __typename: "TeamsHook"
        };
      }
    },
    Tenant: {
      siteData: cursorBasedPagination(),
      roomData: cursorBasedPagination(),
      sites: relayPagination(),
      rooms: relayPagination()
    }
  }
};
export default cacheExchange(opts);
